module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/section02_07_american-village-c95c6a879b4bf3bf68ae537c32aad909.jpg";